module.exports = __webpack_public_path__ + "img/04.90d68b9d.jpg";